export default "__VITE_ASSET__BolaaPYI__"